<template>
	<div class="end-talk-item" :class="{'active':session_id == source.session_id}" @click="clickTab(source)">
		<div class="avatar-box">
			<img :src="source.headimgurl"/>
		</div>
		<div class="card-box">
			<div class="title">
				<span class="nickname">{{source.nickname}}</span>
			</div>
			<div class="desc">
				<p>
					<span class="text"><i class="iconfont" :class="getCnannelIcon(source.channel)"></i></span>
					<time>{{formateDate(source)}}</time>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { friendlyFormatTime, getCnannelIcon } from '@/utils/imService';
	export default {
		props:{
			source: {
			  type: Object,
			  default () {
				return {}
			  }
			},
			session_id: {
			  type: String,
			  default () {
				return ''
			  }
			},
		},
		methods:{
			getCnannelIcon,
			clickTab(data){
				let parent = this.$parent;
				parent = parent.$parent;
				parent.$emit('toSwitchUserTab',data);
			},
			formateDate(data){
				if(typeof data.sendtime == 'number') return friendlyFormatTime(this.$dayjs(data.sendtime).format('YYYY-MM-DD HH:mm:ss'));
				return friendlyFormatTime(data.sendtime);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.end-talk-item {
		padding: 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		cursor: pointer;
		&:hover {
			background: #F6F7F9;
		}
		&.active {
			background-color: #edf5ff;
		}
		.avatar-box {
			width: 45px;
			height: 45px;
			flex-shrink: 0;
			background-color: #508afe;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: white;
			position: relative;
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
				background-color: white;
			}
		}
		.card-box {
			display: flex;
			align-content: center;
			flex-direction: column;
			flex: 1 1;
			margin-left: 10px;
			width: calc(100% - 45px);
			time {
				float: right;
				color: #838a9d;
				font-size: 12px;
			}
			.title {
				 line-height: 22px;
				.nickname {
					 font-size: 14px;
					 color: #3c4353;
					 font-weight: 500;
					 display: inline-block;
					 width: 100%;
					 overflow: hidden;
					 text-overflow: ellipsis;
					 white-space: nowrap;
					 line-height: 22px;
				}
			}
			.desc {
				line-height: 22px;
				.text {
					font-size: 12px;
					color: #838a9d;
				}
			}
			
		}
	}
</style>
